// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../home/node/site/node_modules/css-loader/index.js?minimize!../../../../../../home/node/site/node_modules/vue-loader/lib/style-compiler/index.js?{\"optionsId\":\"0\",\"vue\":true,\"scoped\":false,\"sourceMap\":false}!../../../../../../home/node/site/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Serp.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../../home/node/site/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("3cae07a2", content, true, {});


//////////////////
// WEBPACK FOOTER
// /home/node/site/node_modules/vue-style-loader!/home/node/site/node_modules/css-loader?minimize!/home/node/site/node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!/home/node/site/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/serp/Serp.vue
// module id = 356
// module chunks = 0